// Status words (NIGHT-FACILITIES-2026-10-28c §2): the one glossary of what a request or a candidate card is "at", in
// plain words. The portal page, the status emails and the weekly summary (the notifier imports this file, as it does
// next.js) and the CRM (handed over by name: public/status-words.js, also served at /status-words.js) all read these.
// The database writes its email lines with the same words; test/unit/status-words.test.mjs holds the two together and
// checks that every status in the database's enums has words here.

// facility_requests.status -> its word, and what it means to the facility
export const REQUEST_STATUS = {
  received: 'Received',
  quoting: 'Quoting',
  candidates_presented: 'Candidates presented',
  filled: 'Filled',
  closed: 'Closed',
  expired: 'Expired',
};
export const REQUEST_MEANING = {
  received: 'We have your request. A recruiter reviews it next.',
  quoting: "We're confirming the rate and looking for candidates.",
  candidates_presented: "We've shown you one or more candidates. Each waits for your Interested or Pass.",
  filled: 'Someone is starting in this role.',
  closed: 'This request is no longer active. It was closed by you or by us.',
  expired: 'Its start date passed with no recent activity, so it closed on its own.',
};

// the steps a facility sees on an open request, in order (closed and expired are not steps: they end it)
export const REQUEST_STEPS = ['received', 'quoting', 'candidates_presented', 'filled'];

// a candidate card: facility_presented.staff_status (interview, placed, unavailable), plus the two states a card is in
// without one -- just presented, and an interview with a booked time
export const CARD_STATUS = {
  presented: 'Presented',
  interview: "We're arranging an interview",
  booked: 'Interview booked',
  placed: 'Placed',
  unavailable: 'No longer available',
};
export const CARD_MEANING = {
  presented: 'Waiting for your Interested or Pass.',
  interview: "You said Interested. We're setting up a time with the candidate.",
  booked: 'The interview has a time. Add it to your calendar.',
  placed: 'This candidate is starting with you.',
  unavailable: 'This candidate took another role or stepped back.',
};

// a request copied from an earlier one with "Post again": the word for the action and for the history line
export const POSTED_AGAIN = 'Posted again';

/** The word for a request status; an unknown status is shown as is, never blank. */
export const requestWord = (s) => REQUEST_STATUS[s] || String(s || '');

/** The word for a card: booked beats the staff status; no staff status is "Presented". */
export function cardWord(c) {
  if (c && c.offer && c.offer.booked_at) return CARD_STATUS.booked;
  return CARD_STATUS[c && c.staff_status] || (c && c.staff_status) || CARD_STATUS.presented;
}
